import script from "./SMSCampaignsCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsCreate.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsCreate.vue?vue&type=style&index=0&id=7684589c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7684589c"]])

export default __exports__